import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

import { NavBar } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { isFeishu } from '@/utils/feishu'
import { isApp } from '@/utils/client'
import { isWechatFlag } from '@/utils/weixin'
import { isTudoApp } from '@/utils/tudo'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isBranchManagerApp } from '@/utils/sandsTalkBranchManager'
import { computed } from 'vue'

interface IProps {
  titleConfig?: {
    title?: string
    leftText?: string
    leftArrow?: boolean
    fixed?: boolean
    selfClick?: boolean
  }
  showTitle?: boolean
  feishuShow?: boolean
  weixinShow?: boolean
  tudoShow?: boolean
  wisdomRabbitApp?: boolean
  sandsTalkNative?: boolean
  sandsTalkPhOutfieldApp?: boolean
  branchManagerApp?: boolean
  sandsTalkMsFlutterApp?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    titleConfig: { default: () => {
    return {
      title: '',
      leftText: '',
      leftArrow: true,
      fixed: false,
      selfClick: false
    }
  } },
    showTitle: { type: Boolean, default: true },
    feishuShow: { type: Boolean, default: false },
    weixinShow: { type: Boolean, default: false },
    tudoShow: { type: Boolean, default: false },
    wisdomRabbitApp: { type: Boolean, default: false },
    sandsTalkNative: { type: Boolean },
    sandsTalkPhOutfieldApp: { type: Boolean },
    branchManagerApp: { type: Boolean },
    sandsTalkMsFlutterApp: { type: Boolean }
  },
  emits: ["goBack", "rightClick"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter()
const route = useRoute()

// 判断是否为驰钧 App
const isChijunApp = computed(() => {
  return localStorage.getItem('isCnDriverAppSource') === 'cnChijunApp'
})



const emit = __emit

const meta = route.meta

const onClickLeft = (selfClick: boolean) => {
  if (!selfClick) {
    router.go(-1)
  }
  emit('goBack')
}
const onClickRight = () => {
  emit('rightClick')
}

return (_ctx: any,_cache: any) => {
  return (
      (!_unref(isFeishu) || __props.feishuShow) &&
      !_unref(isApp) &&
      (!_unref(isWechatFlag) || __props.weixinShow) &&
      (!_unref(isTudoApp) || __props.tudoShow) &&
      (!_unref(isSandsTalkFlutterApp) || __props.sandsTalkNative) &&
      (!_unref(isSandsTalkPhOutfieldApp) || __props.sandsTalkPhOutfieldApp) &&
      (!_unref(isWisdomRabbitApp) || __props.wisdomRabbitApp) &&
      (!_unref(isBranchManagerApp) || __props.branchManagerApp) &&
      (!_unref(isSandsTalkMSFlutterApp) || __props.sandsTalkMsFlutterApp) &&
      !isChijunApp.value
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(NavBar), {
          title: __props.titleConfig.title,
          fixed: __props.titleConfig.fixed,
          "left-text": __props.titleConfig.leftText,
          "left-arrow": __props.titleConfig.leftArrow !== false ? true : false,
          border: false,
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (onClickLeft(__props.titleConfig.selfClick))),
          onClickRight: onClickRight,
          "z-index": "500"
        }, {
          title: _withCtx(() => [
            (__props.showTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.titleConfig.title || _ctx.$t(`${_unref(meta).title}`)), 1))
              : _renderSlot(_ctx.$slots, "title", { key: 1 })
          ]),
          right: _withCtx(() => [
            _renderSlot(_ctx.$slots, "right")
          ]),
          _: 3
        }, 8, ["title", "fixed", "left-text", "left-arrow"])
      ]))
    : _createCommentVNode("", true)
}
}

})